/**
 * CRUD Folder CrmObjects
 */

export const FOLDER_CREATED = 'FOLDER_CREATED';
export const FOLDER_DELETED = 'FOLDER_DELETED';
export const FOLDER_SELECTED = 'FOLDER_SELECTED';
export const FOLDER_UPDATED = 'FOLDER_UPDATED';
export const ASSET_ADDED_TO_FOLDER = 'ASSET_ADDED_TO_FOLDER';